"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingTypeEnum = void 0;
var MeetingTypeEnum;
(function (MeetingTypeEnum) {
  /** Тип не определён (быстрый митинг) */
  MeetingTypeEnum[MeetingTypeEnum["not_defined"] = 0] = "not_defined";
  /** митинг 1:1 */
  MeetingTypeEnum[MeetingTypeEnum["single"] = 1] = "single";
  /** групповой митинг */
  MeetingTypeEnum[MeetingTypeEnum["group"] = 2] = "group";
  /** большая группа с ограничениями */
  MeetingTypeEnum[MeetingTypeEnum["webinar"] = 3] = "webinar";
  /** большое количество пользователей */
  MeetingTypeEnum[MeetingTypeEnum["stream"] = 4] = "stream";
  /** групповой митинг для разговорной практики */
  MeetingTypeEnum[MeetingTypeEnum["talk"] = 5] = "talk";
})(MeetingTypeEnum = exports.MeetingTypeEnum || (exports.MeetingTypeEnum = {}));
